import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class DateFullMonthAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: any): string {
        return formatDate(date, 'd MMMM yyy', 'nl');
    }
}
